import { BaseRouteService } from "core/services";

class PivotRouteService extends BaseRouteService {
	constructor() {
		super("person-tasks");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,dateFrom,dateTo,department}`, filter);
	}	
}

export default PivotRouteService;